<template lang="pug">
    div(:id="mapId", v-bind:style="styleObj")
</template>
<style></style>
<script>
import { leaflet } from 'leaflet'
export default {
    props: {
       initLat: {
        type: Number,
        default: 20
      },
       initLon: {
        type: Number,
        default: -103
      },
      mapWidth: {
        type: Number,
        default: 600
      },
      mapHeight: {
        type: Number,
        default: 400
      },
      coordsA: {
        lat:{
          type: Number,
          default: 20
        },
        lng:{
          type: Number,
          default: -103
        }
      },
      coordsB: {
        lat:{
          type: Number,
          default: 20
        },
        lng:{
          type: Number,
          default: -103
        }
      },
    },
    data: function () {
        return {
            mapId: this.$uid(),
            lat: this.initLat,
            lon: this.initLon,
            styleObj: {
              'background-color': 'black',
              width: `${this.mapWidth}px`,
              height: `${this.mapHeight}px`
            }
        }
    },
    methods: {
      initializingMap() {
        this.map = window.L.map(this.mapId, {
            attributionControl: false
        }).setView(
            [33.9758773, -103.3537223], 1);
        this.tileLayer = window.L.tileLayer(
            'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 18
            }
        ).addTo(this.map);
      },
      /**
       * On edit mode set the map and marker for existing values.
       */
      setMap(){
          let coords = {
              lat: this.lat,
              lng: this.lon
          };
          const markerx = {
              visible: true,
              draggable: true,
              icon: L.divIcon({
                  html: '<i class="mdi mdi-crosshairs-gps map__icon primary--text" style="font-size: 40px;"></i>',
                  iconSize: [30, 30],
                  className: 'map__icon-wrapper'
              })
          };
          if(this.map)
          this.map.remove();
          this.map = L.map(this.mapId).setView(coords, 17);
          this.tileLayer = window.L.tileLayer(
                'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                  maxZoom: 18
                }
          ).addTo(this.map);
          if(this.initLat!=20)
          {
            var marker = L.marker(coords, markerx)
            .addTo(this.map);
            marker.addEventListener("dragend", this.getGPS);
          }
          if(this.coordsA.lat!=20 && this.coordsA.lng!=-130)
          {
            var markerA = L.marker(this.coordsA, markerx)
                .addTo(this.map);
            if(this.coordsB.lat!=20 && this.coordsB.lng!=-130)
            {
              var markerB = L.marker(this.coordsB, markerx)
                  .addTo(this.map);
              var polylinePoints = [
                this.coordsA, this.coordsB
              ];
              var polyline = L.polyline(polylinePoints).addTo(this.map);
              var center = L.latLngBounds([this.coordsA, this.coordsB]);
              console.log(center);
              this.map.fitBounds([center], 10);
            }
          }
      },
      getGPS(eventx) {
            this.lat = eventx.target._latlng.lat;
            this.lon = eventx.target._latlng.lng;
        },
    },
    mounted() {
        this.setMap()
    }
 }
</script>
